module.exports = __webpack_public_path__ + "img/zhyly-7.85e5d2ba.png";